"use strict";

export class TimeoutError extends Error {
  constructor(name, timeoutMs) {
    super(`Call to "${name}" timed out after ${timeoutMs}ms`);
    this.name = 'TimeoutError';
  }
}
export class HandlerError extends Error {
  constructor(name, code, originalMessage) {
    super(`Handler for "${name}" threw [${code}]: ${originalMessage}`);
    this.name = 'HandlerError';
  }
}
export class DisposedError extends Error {
  constructor(name) {
    super(`Bridge disposed while call to "${name}" was in flight`);
    this.name = 'DisposedError';
  }
}
//# sourceMappingURL=errors.js.map